// extracted by mini-css-extract-plugin
export default {"form":"EditService_form__8+DV8","error":"EditService_error__ngpL6","actions":"EditService_actions__6DyKS"};